import { Link } from 'react-router';
import { Club } from '@repo/types';
import { ClubNameType } from '../../../fixtures/contracts';
import { Image, ImageVariant } from '../../../common/components/Image';

export type ClubCardProps = {
  club: Club;
  nameType?: ClubNameType;
  style?: React.CSSProperties;
};

function ClubCard({
  club: { slug, fullName, shortName, nickName, threeLetterName, logo },
  nameType = ClubNameType.FullName,
  style,
}: ClubCardProps): JSX.Element {
  const getClubName = () => {
    switch (nameType) {
      case ClubNameType.ThreeLetterName:
        return threeLetterName ?? 'N/A';
      case ClubNameType.ShortName:
        return shortName ?? 'N/A';
      case ClubNameType.FullName:
        return fullName ?? 'N/A';
      case ClubNameType.NickName:
        return nickName ?? 'N/A';
      default:
        return shortName ?? 'N/A';
    }
  };
  const clubName = getClubName();

  return (
    <div className="club-card" style={style}>
      <Link className="club-card__link" to={`/clubs/${slug}`}>
        <Image
          className="club-card__logo"
          alt={clubName}
          src={logo || 'default-team-badge.webp'}
          width="150"
          height="150"
          variant={ImageVariant.SquareLogoLarge}
        />
        <h4 className="club-card__name">{clubName}</h4>
      </Link>
    </div>
  );
}

export default ClubCard;
